import { Dispatch, ReducerState, ReducerAction, createContext } from "react";
import MoreInfoReducer from "./more_info.reducer";

type MoreInfoReducerState = ReducerState<typeof MoreInfoReducer>;
export type MoreInfoDispatchAction = Dispatch<ReducerAction<typeof MoreInfoReducer>>;
type MoreInfoContextType = [MoreInfoReducerState, MoreInfoDispatchAction];

export const MoreInfoContext = createContext<MoreInfoContextType>([{ info: null }, (state) => state]);
